<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Quản lý nhân sự Chấm thi, Coi thi</h3>
      </div>
      <div class="card-title">
        <button class="btn btn-success" @click="addAdmin">
          <i class="el-icon-plus"></i> Thêm mới
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col-2">
          <div class="form-group mb-0">
            <label class="small">Nhân sự admin</label>
            <el-input
                v-model="filters.keyword"
                clearable
                placeholder="Nhập họ tên, mã, số điện thoại"
                @input="debouncedFetch"
            />
          </div>
        </div>
        <div class="col-2">
          <div class="form-group mb-0">
            <label class="small">Loại nhân sự</label>
            <el-select
                v-model="filters.type_id"
                clearable
                placeholder="Chọn loại nhân sự"
                style="width: 100%"
                @change="fetchList"
            >
              <el-option
                  v-for="item in ADMIN_PROFILE_TYPE.filter(item => item.value !== 2)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group mb-0">
            <label class="small">Trạng thái</label>
            <el-select
                v-model="filters.status"
                clearable
                placeholder="Chọn trạng thái"
                style="width: 100%"
                @change="fetchList"
            >
              <el-option
                  v-for="item in STATUS"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group mb-0">
            <label class="small">Hình thức làm việc</label>
            <el-select
                v-model="filters.type_work_id"
                clearable
                placeholder="Chọn hình thức"
                style="width: 100%"
                @change="fetchList"
            >
              <el-option
                  v-for="item in TYPE_WORK.filter(item => item.id !== 0)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="col-3 d-flex align-items-end justify-content-end">
          <button
              :class="{ 'spinner spinner-white spinner-left': loading }"
              class="btn btn-primary font-weight-bold"
              @click="fetchList"
          >
            <i class="fa fa-search"></i> Tìm kiếm
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table
              class="table table-vertical-center table-bordered"
              style="min-height: 100px"
          >
            <thead>
            <tr>
              <th>Mã nhân sự</th>
              <th>Họ và tên</th>
              <th>Số điện thoại</th>
              <th>Loại nhân sự</th>
              <th>Năng lực chấm</th>
              <th>Hình thức trực test</th>
              <th>Cơ sở trực offline</th>
              <th>Trạng thái</th>
              <th>Thời gian tạo</th>
              <th class="text-center">Hành động</th>
            </tr>
            </thead>
            <tbody v-if="admins.length > 0">
            <tr v-for="admin in admins" :key="admin.id">
              <td>{{ admin.user_id + MHV || "" }}</td>
              <td>{{ admin.user_name }}</td>
              <td>{{ admin.user_phone }}</td>
              <td>
                              <span class="badge badge-info" :class="classTypeIds[admin.type_id]">{{
                                  ADMIN_PROFILE_TYPE.find((item) => item.value === admin.type_id)?.label
                                }}
                              </span>
              </td>
              <td>
                <span>{{ admin.mark_level }}</span>
              </td>
              <td>
                                <span class="badge " :class="classTypeIds[admin.type_work_id]">{{
                                    TYPE_WORK.find((item) => item.id === admin.type_work_id)?.name
                                  }}</span>
              </td>
              <td>
                  <span>{{
                      admin.type_work_id === TYPE_WORK_OFFLINE
                          ? admin.branch_name
                          : "trống"
                    }}</span>
              </td>
              <td>
                  <span
                      :class="
                      admin.status === 1
                        ? 'badge badge-success'
                        : 'badge badge-secondary'
                    "
                  >
                    {{ STATUS.find((item) => item.id === admin.status)?.name }}
                  </span>
              </td>
              <td>{{ formatDateTime(admin.created_at) }}</td>
              <td class="text-center">
                <!-- <button class="btn btn-icon btn-xs btn-outline-primary" @click="viewSchedule(admin)" title="Lịch đi làm">
                  <i class="el-icon-date"></i>
                </button> -->
                <button
                    class="btn btn-icon btn-xs btn-outline-warning ml-2"
                    title="Sửa"
                    @click="editAdmin(admin)"
                >
                  <i class="el-icon-edit"></i>
                </button>
                <button
                    class="btn btn-icon btn-xs btn-outline-danger ml-2"
                    title="Xoá"
                    @click="deleteAdmin(admin)"
                >
                  <i class="el-icon-delete"></i>
                </button>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td class="text-center" colspan="10">Không có dữ liệu</td>
            </tr>
            </tbody>
          </table>
          <div
              class="edu-paginate mx-auto text-center mt-10 mb-5"
              style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 50px;
            "
          >
            <paginate
                v-model="currentPage"
                :click-handler="handlePageChange"
                :container-class="'pagination b-pagination'"
                :margin-pages="1"
                :next-class="'page-link'"
                :next-link-class="'next-link-item'"
                :next-text="'Sau'"
                :page-class="'page-item'"
                :page-count="Math.ceil(total / pageSize)"
                :page-range="3"
                :pageLinkClass="'page-link'"
                :prev-class="'page-link'"
                :prev-link-class="'prev-link-item'"
                :prev-text="'Trước'"
            />
          </div>
          <div
              class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3"
          >
            <div class="d-flex align-items-center">
              <div class="mr-3">
                Tổng số bản ghi: <b>{{ total }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AdminCreateModal
        v-if="showCreateModal"
        :branches="branches"
        :visible="showCreateModal"
        @close="showCreateModal = false"
        @success="handleCreateSuccess"
    />
    <AdminEditModal
        :admin="editingAdmin"
        :branches="branches"
        :visible="showEditModal"
        @close="onEditModalClose"
        @updated="handleUpdateSuccess"
    />
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import AdminCreateModal from "./AdminCreateModal.vue";
import AdminEditModal from "./AdminEditModal.vue";
import {DELETE_MARKING_ADMIN, GET_MARKING_ADMIN_LIST,} from "@/core/services/store/marking/admin.module";
import {MHV} from "@/core/option/attendanceStudent";
import {
  ADMIN_TYPE,
  ADMIN_TYPE_TAG,
  STATUS,
  STATUS_TAG,
  TYPE_WORK,
  TYPE_WORK_TAG,
} from "@/core/option/academic/adminOption";
import {GET_ALL_BRANCHES} from "@/core/services/store/center/branch.module";
import {ADMIN_PROFILE_TYPE, TYPE_WORK_OFFLINE} from "@/core/option/adminProfile";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  name: "AdminList",
  components: {Paginate, AdminCreateModal, AdminEditModal},
  data() {
    return {
      MHV: MHV,
      ADMIN_PROFILE_TYPE: ADMIN_PROFILE_TYPE,
      ADMIN_TYPE: ADMIN_TYPE,
      TYPE_WORK: TYPE_WORK,
      TYPE_WORK_TAG: TYPE_WORK_TAG,
      ADMIN_TYPE_TAG: ADMIN_TYPE_TAG,
      STATUS: STATUS,
      STATUS_TAG: STATUS_TAG,
      TYPE_WORK_OFFLINE: TYPE_WORK_OFFLINE,
      admins: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      loading: false,
      filters: {
        keyword: "",
        type_work_id: "",
        type_id: "",
        status: "",
      },
      classTypeIds: {
        0: "badge-primary",
        1: "badge-success",
        2: "badge-warning",
      },
      showCreateModal: false,
      branches: [],
      showEditModal: false,
      editingAdmin: null,
    };
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý nhân sự Chấm thi, Coi thi", name: 'AdminList'},
      {title: "Coi thi - Chấm thi"}
    ]);
    this.debouncedFetch = this.debounce(this.fetchList, 400);
    await this.fetchList();
    await this.fetchBranches();
  },
  methods: {
    async fetchBranches() {
      await this.$store.dispatch(GET_ALL_BRANCHES).then((res) => {
        this.branches = res || [];
      }).catch((e) => {
        this.$message.error("Không thể tải danh sách!");
      });
    },
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch(GET_MARKING_ADMIN_LIST, {
        page: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.filters.keyword,
        type_id: this.filters.type_id,
        type_work_id: this.filters.type_work_id,
        status: this.filters.status,
      }).then((res) => {
        this.admins = res.data || [];
        this.total = res.pagination?.total || 0;
      }).catch((e) => {
        this.$message.error("Không thể tải danh sách!");
      }).finally(() => {
        this.loading = false;
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    addAdmin() {
      this.showCreateModal = true;
    },
    handleCreateSuccess() {
      this.fetchList();
    },
    editAdmin(row) {
      this.editingAdmin = {...row};
      this.showEditModal = true;
    },
    onEditModalClose() {
      this.showEditModal = false;
      this.editingAdmin = null;
    },
    handleUpdateSuccess() {
      this.fetchList();
    },
    async deleteAdmin(admin) {
      const messageConfirm =
          "Bạn có chắc chắn muốn xóa nhân sự " + admin.user_name + " không?";
      this.$confirm(messageConfirm, "Xác nhận", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(async () => {
        this.loading = true;
        try {
          const res = await this.$store.dispatch(
              DELETE_MARKING_ADMIN,
              admin.id
          );
          if (!res.error) {
            this.$message.success("Xoá nhân sự thành công");
            await this.fetchList();
          } else {
            this.$message.error("Xoá nhân sự thất bại 11111111");
          }
        } catch (e) {
          this.$message.error("Xoá nhân sự thất bại 44444444444");
        } finally {
          this.loading = false;
        }
      });
    },
    formatDateTime(date) {
      if (!date) return "";
      const d = new Date(date);
      return (d.toLocaleTimeString("vi-VN", {hour12: false}) + " " + d.toLocaleDateString("vi-VN"));
    },
    debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    debouncedFetch() {
      this.debounce(this.fetchList, 400)();
    },
  },
  watch: {
    "filters.keyword": function () {
      this.debouncedFetch();
    },
    "filters.type": function () {
      this.fetchList();
    },
    "filters.status": function () {
      this.fetchList();
    },
  },
};
</script>

<style scoped>
.pagination {
  margin-bottom: 0;
}
</style>
